import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { FormControlLabel } from "@mui/material";
import TextField from "@mui/material/TextField";
import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { DeleteButton, EditButton, List, useDataGrid } from "@refinedev/mui";
import React, { useState } from "react";

export const FollowersSettingsList = () => {
  const { dataGridProps, setFilters, setCurrent, setPageSize  } = useDataGrid({
    sorters: {
      initial: [
        {
          field: "updatedAt",
          order: "desc"
        }
      ]
    },
    pagination: {
      pageSize: 10
    }
  });

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 80,
        hideable: false,
      },
      {
        field: "badge.name",
        headerName: "BadgeName",
        minWidth: 160,
        flex: 1,
        hideable: false,
      },
      {
        field: "gte",
        headerName: "Gte",
        minWidth: 80,
        flex: 1,
        hideable: false,
      },
      {
        field: "name",
        headerName: "Name",
        minWidth: 130,
        flex: 1,
        hideable: false,
      },
      {
        field: "description",
        headerName: "Description",
        minWidth: 130,
        flex: 1,
        hideable: false,
      },
      {
        field: "updatedAt",
        headerName: "UpdatedAt",
        minWidth: 170,
        flex: 1,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.updatedAt) {
            return new Date(row.updatedAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "createdAt",
        headerName: "CreatedAt",
        minWidth: 170,
        flex: 1,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.createdAt) {
            return new Date(row.createdAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        hideable: false,
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              <DeleteButton hideText recordItemId={row.id} />
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 100,
      },
    ],
    []
  );

  // search parts
  const [name, setName] = useState("");
  const handleFilter = () => {
    setCurrent(1);
    setPageSize(10);
    let searchArr: { field: string; value: string; operator: string }[] = [];
    if (name) {
      searchArr.push({
        field: "name[$ilike]",
        value: `%${name}%`,
        operator: "eq",
      });
    }
    setFilters(searchArr as any);
  };
  const clearFun = () => {
    setName("");
  };
  return (
    <List>
      <FormControlLabel
        label=""
        style={{ width: "100%" }}
        control={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-end",
              width: "100%",
              marginLeft: "19px",
              marginBottom: "12px",
            }}
          >
            <div style={{ width: "90%", paddingBottom: "3px" }}>
              <TextField
                id="standard-basic"
                label="Name"
                variant="standard"
                value={name}
                onChange={(e) => setName(e.target.value)}
                fullWidth
              />
            </div>
            <div style={{ width: "60px" }}>
              <ClearOutlinedIcon onClick={clearFun} />
              <SearchIcon onClick={handleFilter} />
            </div>
          </div>
        }
      />
      <DataGrid {...dataGridProps} columns={columns} autoHeight paginationMode="server" rowsPerPageOptions={[10,20,50]} disableColumnFilter/>
    </List>
  );
};
